<div class="auth-container">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12 col-sm-12 text-center">
        @if (isVerifying || showError || response !== 'yes') {
          <img
            src="/assets/images/octopus-generic-header.png"
            alt="Octopus Banner"
            height="100%"
            width="60%"
            />
        }
        @if (!isVerifying && !showError && response === 'yes') {
          <img
            src="/assets/images/all-set-tablet-10days.png"
            alt="All Set!"
            height="100%"
            width="60%"
            />
        }
      </div>
    </div>

    <br />

    <div class="row">
      <div class="col-md-12 col-lg-12 col-sm-12 text-center">
        @if (isVerifying) {
          <div class="row">
            <div class="col-md-12 d-flex justify-content-center">
              <mat-spinner diameter="24"></mat-spinner>
              <span class="mx-2">Verifying your response</span>
            </div>
          </div>
        }

        @if (!isVerifying && showError && response) {
          <h5>Oops! Something went wrong.</h5>
          <p class="mt-2">
            Contact
            <a href="https://playoctopus.com/help"
              >Play Octopus Support</a
              >
              .
            </p>
          }

          @if (
            !isVerifying && !showError && response === 'submitted'
            ) {
            <h5>You have already submitted a response.</h5>
            <p class="mt-2">
              To change your response, please email
              contact&#64;playoctopus.com. Thank you!
            </p>
          }

          @if (!isVerifying && !showError && response === 'no') {
            <h4>Thanks for letting us know!</h4>
            <p class="mt-2">
              If you would like to re-initiate your application in the
              future, email contact&#64;playoctopus.com. Best of luck with
              your rideshare!
            </p>
          }

          @if (!isVerifying && !showError && response === 'not_yet') {
            <h4>Thanks for letting us know!</h4>
            <p class="mt-2">
              We'll check-in with you after a month but if you plan to
              start earlier, then email contact&#64;playoctopus.com. We
              look forward to you joining us soon!
            </p>
          }

          @if (!isVerifying && !showError && response === 'yes') {
            <h5>
              We will email details and updates regarding your tablet
              to {{ email || 'your email on file' }}.
            </h5>
          }
        </div>
      </div>
    </div>
  </div>
